module.exports = __webpack_public_path__ + "img/icon-folder-tree-child.97ea5975.svg";